import type { MetaFunction, LinksFunction } from 'remix';

import styles from '~/styles/routes/contact.css';

export const links: LinksFunction = () => {
  return [{ rel: 'stylesheet', href: styles }];
};

export const meta: MetaFunction = () => {
  return {
    title: '@GhosteTheDev | Contact',
    description: 'All things created by Ghoste and where to find him!',
  };
};

export default function Contact() {
  return <>contact</>;
}
